<div class="main-join-wrapper">
<div class="scad-title__semi-bold mb-3">Join</div>
<div class="scad-title__sm-label"> The Join tool enables discovering similarities and linking columns from two tables. These tables can be connected based on a common record identifier or their record positions.</div>

<div class="d-flex align-items-center mt-3 mb-3">
  <div class="scad-radio">
    <label class="scad-title__sm-thin-gray2"><input type="radio" class="input-radio blue" checked name="chart" > Join by a common identifier </label>
  </div>
</div>

<div class="d-flex align-items-center mb-3">
  <div class="scad-radio">
    <label class="scad-title__sm-thin-gray2"><input type="radio" class="input-radio blue" name="chart"> Join by position </label>
  </div>
</div>

<div class="mt-4">
  <div class="scad-input mb-3">
    <div class="scad-title__sm-thin-gray mt-3 mb-2">Left Table Identifier</div>
    <ng-select class="shNgclass ng-select-default"  placeholder="Select Left item" [(ngModel)]="_fb.activeNode?.leftDataSelected?.key ?? nulll" [items]="_fb.activeNode?.LeftJoinFormat" bindLabel="value" bindValue="key"
    (change)="LeftDataChange($event)" ></ng-select>
  </div>
  <div class="scad-input mb-3">
    <div class="scad-title__sm-thin-gray mt-3 mb-2">Right Table Identifier</div>
    <ng-select class="shNgclass ng-select-default"  placeholder="Select Right Item" [(ngModel)]="_fb.activeNode?.rightDataSelected?.key ?? nulll2" [items]="_fb.activeNode?.RightJoinFormat" bindLabel="value" bindValue="key"
    (change)="RightDataChange($event)" ></ng-select>
  </div>
</div>

<div class="scad-title__sm-label mb-3"> Left Join Output (L): Includes the records from the left table that do not have corresponding identifiers in the right table.</div>
<div class="scad-title__sm-label mb-3"> Right Join Output (R): Contains the records from the right table that do not have corresponding identifiers in the left table.</div>
<div class="scad-title__sm-label mb-3"> Common Join Output (J): Contains the records that has matching identifier in both the left and the right tables.</div>


<div class="join-type">
    <div class="au-join-label">
      <label for="left_join">{{"L"}}</label>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="27" viewBox="0 0 37 24">
        <g id="Group_14010" data-name="Group 14010" transform="translate(-10420 -3399)">
          <g id="Group_13959" data-name="Group 13959" transform="translate(-24 -14)">
            <circle id="Ellipse_2523" data-name="Ellipse 2523" cx="12" cy="12" r="12" transform="translate(10444 3413)" fill="#1847DF"/>
            <circle id="Ellipse_2524" data-name="Ellipse 2524" cx="12" cy="12" r="12" transform="translate(10457 3413)" fill="#fff"/>
            <path id="Ellipse_2524_-_Outline" data-name="Ellipse 2524 - Outline" d="M12,1A11,11,0,0,0,4.222,19.778,11,11,0,0,0,19.778,4.222,10.928,10.928,0,0,0,12,1m0-1A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z" transform="translate(10457 3413)" fill="#1847DF"/>
            <path id="Ellipse_2525" data-name="Ellipse 2525" d="M12,1A11,11,0,0,0,4.222,19.778,11,11,0,0,0,19.778,4.222,10.928,10.928,0,0,0,12,1m0-1A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z" transform="translate(10444 3413)" fill="#1847DF"/>
          </g>
        </g>
      </svg>

    <div class="au-join-label">
      <label for="inner_join">{{"J"}}</label>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="27" viewBox="0 0 37 24">
        <g id="Group_14011" data-name="Group 14011" transform="translate(-10422 -3434)">
          <g id="Group_13961" data-name="Group 13961">
            <g id="Group_13960" data-name="Group 13960" transform="translate(20903 6871) rotate(180)">
              <circle id="Ellipse_2523" data-name="Ellipse 2523" cx="12" cy="12" r="12" transform="translate(10444 3413)" fill="#fff"/>
              <path id="Ellipse_2523_-_Outline" data-name="Ellipse 2523 - Outline" d="M12,1A11,11,0,0,0,4.222,19.778,11,11,0,0,0,19.778,4.222,10.928,10.928,0,0,0,12,1m0-1A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z" transform="translate(10444 3413)" fill="#1847DF"/>
              <circle id="Ellipse_2526" data-name="Ellipse 2526" cx="12" cy="12" r="12" transform="translate(10444 3413)" fill="#fff"/>
              <path id="Ellipse_2526_-_Outline" data-name="Ellipse 2526 - Outline" d="M12,1A11,11,0,0,0,4.222,19.778,11,11,0,0,0,19.778,4.222,10.928,10.928,0,0,0,12,1m0-1A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z" transform="translate(10444 3413)" fill="#1847DF"/>
              <path id="Ellipse_2524" data-name="Ellipse 2524" d="M12,1A11,11,0,0,0,4.222,19.778,11,11,0,0,0,19.778,4.222,10.928,10.928,0,0,0,12,1m0-1A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z" transform="translate(10457 3413)" fill="#1847DF"/>
            </g>
            <ellipse id="Ellipse_2527" data-name="Ellipse 2527" cx="4.5" cy="9" rx="4.5" ry="9" transform="translate(10436 3437)" fill="#1847DF"/>
            <path id="Ellipse_2527_-_Outline" data-name="Ellipse 2527 - Outline" d="M4.5,1c-.792,0-1.626.759-2.288,2.083A13.565,13.565,0,0,0,1,9a13.565,13.565,0,0,0,1.212,5.917C2.874,16.241,3.708,17,4.5,17s1.626-.759,2.288-2.083A13.565,13.565,0,0,0,8,9,13.565,13.565,0,0,0,6.788,3.083C6.126,1.759,5.292,1,4.5,1m0-1C6.985,0,9,4.029,9,9s-2.015,9-4.5,9S0,13.971,0,9,2.015,0,4.5,0Z" transform="translate(10436 3437)" fill="#1847DF"/>
          </g>
        </g>
    </svg>

    <div class="au-join-label">
      <label for="right_join">{{"R"}}</label>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="27" viewBox="0 0 37 24">
        <g id="Group_14012" data-name="Group 14012" transform="translate(-68 -271)">
          <g id="Group_13958" data-name="Group 13958" transform="translate(10549 3708) rotate(180)">
            <circle id="Ellipse_2523" data-name="Ellipse 2523" cx="12" cy="12" r="12" transform="translate(10444 3413)" fill="#1847DF"/>
            <circle id="Ellipse_2524" data-name="Ellipse 2524" cx="12" cy="12" r="12" transform="translate(10457 3413)" fill="#fff"/>
            <path id="Ellipse_2524_-_Outline" data-name="Ellipse 2524 - Outline" d="M12,1A11,11,0,0,0,4.222,19.778,11,11,0,0,0,19.778,4.222,10.928,10.928,0,0,0,12,1m0-1A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z" transform="translate(10457 3413)" fill="#1847DF"/>
            <path id="Ellipse_2525" data-name="Ellipse 2525" d="M12,1A11,11,0,0,0,4.222,19.778,11,11,0,0,0,19.778,4.222,10.928,10.928,0,0,0,12,1m0-1A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z" transform="translate(10444 3413)" fill="#1847DF"/>
          </g>
        </g>
      </svg>
  </div>

  <div class="line mt-4 mb-4"></div>


  <div class="select-item">

    <div class="scad-title__sm-label mb-3"  *ngIf="_fb.activeNode?.LeftJoinFormat?.length>0"> Left Table Columns to Join.</div>
    <div *ngFor="let item of _fb?.activeNode?.LeftJoinFormat;let i=index" class="select-item__field">
      <div class="select-item__header" >
        <div class="select-item__field-label">
          <svg  xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
              <circle cx="7.3291" cy="4.3291" r="1.3291" fill="#6A7180"/>
              <circle cx="7.3291" cy="10.7847" r="1.3291" fill="#6A7180"/>
              <circle cx="7.3291" cy="17.2402" r="1.3291" fill="#6A7180"/>
              <circle cx="13.7847" cy="4.3291" r="1.3291" fill="#6A7180"/>
              <circle cx="13.7847" cy="10.7847" r="1.3291" fill="#6A7180"/>
              <circle cx="13.7847" cy="17.2402" r="1.3291" fill="#6A7180"/>
          </svg>
          <div class="scad-checkbox scad-checkbox__small-check" (click)="lft_UpdateCheckbox(i)">
            <input   type="checkbox" [(ngModel)]="item.checked"  name="" id="">
            <label class="scad-title__sm-label-sub" >{{item.key}} </label>
          </div>
        </div>
        <div class="select-item__down-arrow" (click)="itemCollaps(i,'l')">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.66675 6.6665L9.93336 13.3332L15.1429 6.6665" stroke="#364151" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

        </div>
      </div>

      <div [ngClass]="{'item-remove': (item.isCheck === false || item.isCheck === undefined)}" class="select-item__sub-body">
        <div class="pb-3">
          <div class="scad-title__sm-thin-gray mt-3 mb-3"> Rename Column </div>
          <div class="scad-input">
            <input type="text" class="scad-input-half" [(ngModel)]="item.letfUpdatedName" placeholder="Enter Here"  />
          </div>
        </div>
      </div>

    </div>
    <div class="scad-title__sm-label mb-3" *ngIf="_fb.activeNode?.RightJoinFormat?.length>0"> Right Table Columns to Join.</div>
    <div *ngFor="let item of _fb?.activeNode?.RightJoinFormat;let i=index" class="select-item__field">
      <div class="select-item__header">
        <div class="select-item__field-label">
          <svg  xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
              <circle cx="7.3291" cy="4.3291" r="1.3291" fill="#6A7180"/>
              <circle cx="7.3291" cy="10.7847" r="1.3291" fill="#6A7180"/>
              <circle cx="7.3291" cy="17.2402" r="1.3291" fill="#6A7180"/>
              <circle cx="13.7847" cy="4.3291" r="1.3291" fill="#6A7180"/>
              <circle cx="13.7847" cy="10.7847" r="1.3291" fill="#6A7180"/>
              <circle cx="13.7847" cy="17.2402" r="1.3291" fill="#6A7180"/>
          </svg>

          <div class="scad-checkbox scad-checkbox__small-check" (click)="rght_UpdateCheckbox(i)">
            <input type="checkbox"    type="checkbox" [(ngModel)]="item.checked" >
            <label class="scad-title__sm-label-sub" >
              {{item.key}}</label>
          </div>
        </div>
        <div class="select-item__down-arrow" (click)="itemCollaps(i,'r')">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.66675 6.6665L9.93336 13.3332L15.1429 6.6665" stroke="#364151" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
    </div>

    <div [ngClass]="{'item-remove': (item.isCheck === false || item.isCheck === undefined)}" class="select-item__sub-body">
      <div class="pb-3">
        <div class="scad-title__sm-thin-gray mt-3 mb-3"> Rename Column </div>
        <div class="scad-input">
          <input type="text" class="scad-input-half" [(ngModel)]="item.rightUpdatedName" placeholder="Enter Here"  />
        </div>
      </div>
    </div>


     <!-- <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
         <path d="M4.66675 6.6665L9.93336 13.3332L15.1429 6.6665" stroke="#364151" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
     </svg> -->
    </div>

    <div class="line mt-4 mb-4"></div>

    <!-- <div  class="d-flex">
      <button class="scad-btn scad-btn--secondary me-3">Cancel</button>
      <button class="scad-btn scad-btn--primary">Save</button>
    </div> -->

 </div>
</div>
